import camelize from 'camelcase-keys-deep';

export default class LinkedAuction {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  current() {
    return this.env().Auction.getById(this.currentId);
  }
}
